'use strict';

var React = require('react');

var SvgToggleMinor = function SvgToggleMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2 10a6 6 0 0 1 6-6h4a6 6 0 0 1 0 12h-4a6 6 0 0 1-6-6Zm6 4a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"
  }));
};

exports.SvgToggleMinor = SvgToggleMinor;
